import { Mahalle } from './../_models/mahalle';
import { MeetingArea } from './../_models/meeting-area';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MeetingAreasService {
    baseUrl: string = environment.apiUrl + "toplanmaalanlari";

    constructor(private http: HttpClient) { }

    getMeetingAreas(mahalleId?: Number): Observable<MeetingArea[]> {
        
        if (mahalleId != null)
            this.baseUrl = this.baseUrl + '?mahalleid=' + mahalleId;

        return this.http.get<MeetingArea[]>(this.baseUrl);

    }

    getMahalleler() {
        return this.http.get<Mahalle[]>(this.baseUrl + '/mahalleler');
    }
}



// WEBPACK FOOTER //
// ./src/_services/meeting-areas.service.ts